// 食事コマ
export const eatKomas: number[] = [
  4 * 6 + 2, //  朝食 6:30ぐらい → 26コマ
  4 * 10 + 2, // 朝おやつ 10：30、→ 42コマ
  4 * 12 + 2, //  昼食 12：30、→ 50コマ
  4 * 14 + 2, //  昼おやつ 14:30 → 58コマ
  4 * 20 + 0, //  夕食 20:00、→ 80コマ
];
